import type { AppMode } from '@iheartjane/types';
import { Storage, statePostalCode } from '@iheartjane/utils';
import { useMemo } from 'react';

export interface GoldConfig {
  states: string[];
  store_ids: number[];
}

export interface ShouldShowGoldArgs {
  appMode: AppMode;
  goldConfig?: GoldConfig | null;
  state?: string | null;
  storeId?: string | number;
}

export const useShouldShowGold = ({
  appMode,
  goldConfig,
  state,
  storeId,
}: ShouldShowGoldArgs): boolean => {
  return useMemo(() => {
    // check location and store ID and ignore the original janeGold flag
    if (goldConfig) {
      const validState = shouldShowGoldForAppModeAndLocation({
        appMode,
        goldConfig,
        state,
        storeId,
      });

      return validState;
    }

    return true;
  }, [appMode, goldConfig, state, storeId]);
};

export const shouldShowGoldForAppModeAndLocation = ({
  appMode,
  goldConfig,
  state,
  storeId,
}: ShouldShowGoldArgs & { goldConfig: GoldConfig }): boolean => {
  const stateCode =
    statePostalCode(state) || Storage.get<string>('state') || '';

  if (appMode === 'default' && !!stateCode) {
    return goldConfig.states.includes(stateCode);
  }

  // For all other app modes, check the store ID
  if (storeId) {
    return goldConfig.store_ids.includes(Number(storeId));
  }

  return false;
};
